{
  "name": "@ns/company-bank-validation",
  "version": "1.0.0",
  "description": "Validate your company's bank account details",
  "inputs": {},
  "outcomes": {
    "complete": {}
  }
}
